import useScrollToFormAndAnimate from "@Form/hooks/useScrollToFormAndAnimate";
import FormErrorsModel from "@Form/models/FormErrorsModel";
import useIsMobile from "@Hooks/selector/useIsMobile";
import {setFormErrors} from "../reducers/formSlice";
import {serialize} from "@Object/serialize";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {
    activateDepartureStationInput,
    activateDestinationStationInput,
    activateSingleCalendar
} from "@Reducers/mobileSlice";

export default function useValidateForm() {
    const {urlParams} = useAppSelector((state) => state?.form)
    const {animateForm} = useScrollToFormAndAnimate()
    const dispatch = useAppDispatch()
    const isMobile = useIsMobile()

    const checkForErrors = () => {
        const formErrors = new FormErrorsModel(urlParams)
        const noErrors = Object.values(formErrors).every((field) => field === true)

        if (!noErrors && isMobile) {
            animateForm()
        }

        if (isMobile) {
            if (!urlParams?.fromSlug) {
                return dispatch(activateDepartureStationInput(true))
            }

            if (!urlParams?.toSlug) {
                return dispatch(activateDestinationStationInput(true))
            }

            if (!urlParams?.date) {
                return dispatch(activateSingleCalendar(true))
            }
        }

        dispatch(setFormErrors(serialize(formErrors)))

        return noErrors
    }

    return {
        checkForErrors,
    }
}